import {
  ParentData,
  UserData
} from "components/web-checkout/edit-userdata/edit-userdata.types";
import { useRouter } from "next/router";
import { useEffect } from "react";
import { useAuth } from "stores/auth/auth-context";

export const useUpdateUser = () => {
  const router = useRouter();
  const {
    user: { userData }
  } = useAuth();

  useEffect(() => {
    if (userData.primary_user.profile_state === "COMPLETE") {
      router.push("/bimbel");
    }
  }, [userData.primary_user]);

  const getStoredFormData = (): {
    userData?: UserData;
    parentData?: ParentData;
  } | null => {
    if (typeof window !== "undefined") {
      const storedData = sessionStorage.getItem("updateUserFormData");
      if (storedData) {
        try {
          const parsedData = JSON.parse(storedData);
          return {
            userData: parsedData.userData,
            parentData: parsedData.parentData
          };
        } catch (error) {
          console.error("Error parsing updateUserFormData:", error);
        }
      }
    }
    return null;
  };

  const formData = getStoredFormData();

  const userDetails = formData?.userData || {
    name: userData.primary_user?.full_name,
    residence: userData.primary_user?.city || "",
    schoolName: userData.primary_user?.school || "",
    grade: userData.primary_user?.grade,
    curriculum: userData.primary_user?.curriculum,
    email: userData.primary_user?.email
  };

  const parentDetails = formData?.parentData || {
    parentName: userData.parent_user?.name,
    parentPhone: userData.parent_user?.phone_number
  };

  return {
    userDetails,
    parentDetails
  };
};
